"use client"

import { createContext, useContext, useMemo, type PropsWithChildren } from "react"
import { parseAsString, useQueryState } from "nuqs"

export const QUERY_PARAM_KEY = "q"

type SearchQueryContextState = {
  query: string
  setQuery: (query: string) => void
}

const SearchQueryReactContext = createContext<SearchQueryContextState>({
  query: "",
  setQuery: () => null,
})

export function useSearchQuery() {
  const context = useContext(SearchQueryReactContext)

  if (!context) {
    throw new Error("useSearchQueryContext must be used within a SearchQueryContextProvider")
  }

  return useContext(SearchQueryReactContext)
}

export function SearchQueryContext({ children }: PropsWithChildren) {
  const [query, setQuery] = useQueryState(QUERY_PARAM_KEY, parseAsString)

  const value = useMemo(() => {
    return {
      query: query || "",
      setQuery,
    }
  }, [query])

  return <SearchQueryReactContext.Provider value={value}>{children}</SearchQueryReactContext.Provider>
}
